/* Landing sections (hl-*): countdown, copy-code button, autoplaying muted videos. */
(function () {
  'use strict';
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function initCountdown(el) {
    if (el.__hl) return; el.__hl = true;
    var raw = (el.getAttribute('data-hl-countdown') || '').trim();
    var m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return;
    var end = new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, m[4] ? 0 : 59).getTime();
    var daysBox = el.querySelector('[data-days]');
    var u = function (k) { return el.querySelector('[data-unit="' + k + '"]'); };
    var timer;
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { el.hidden = true; if (timer) clearInterval(timer); return; }
      el.hidden = false;
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var mi = Math.floor(s / 60); s -= mi * 60;
      if (daysBox) { daysBox.hidden = d < 1; u('d').textContent = d; }
      u('h').textContent = pad(h); u('m').textContent = pad(mi); u('s').textContent = pad(s);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  function initCopy(btn) {
    if (btn.__hl) return; btn.__hl = true;
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-hl-copy');
      var label = btn.querySelector('small');
      var old = label ? label.textContent : '';
      var done = function () {
        if (!label) return;
        label.textContent = btn.getAttribute('data-done') || old;
        setTimeout(function () { label.textContent = old; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
    });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target.querySelector('video');
      if (!v) return;
      if (e.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.35 }) : null;

  function initVideo(frame) {
    if (frame.__hl) return; frame.__hl = true;
    var v = frame.querySelector('video');
    if (!v) return;
    v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
    frame.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
    if (io && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) io.observe(frame);
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hl-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-hl-copy]').forEach(initCopy);
    scope.querySelectorAll('[data-hl-video]').forEach(initVideo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
